<template>
  <!-- <div class="animated fadeIn"> -->
   <petrolapprove-component>
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          

          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Logistic Approval</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Finance Approval</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <adminapproval style="width:70%;"></adminapproval>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <financeapproval style="width:70%;"></financeapproval>
            </div>


     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  <!-- </div>    -->
</petrolapprove-component>

</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";




import adminapproval from './adminapproval.vue'
import financeapproval from './financeapproval.vue'


export default {
  data: function() {
    return {
      // activeTab: '',
      activeTab: 1,
      adminapproval,
      financeapproval,
      
      name: 'PetrolBill'
     
    };
  },
  components: {
   

    adminapproval,
    financeapproval,
  

  },
 created: function() {
    this.isActiveTab(1);
  },
 
  methods: {
    isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
